// extracted by mini-css-extract-plugin
export default {"Tag":"Tag_Tag__sqME3"};